module.exports = __webpack_public_path__ + "media/ipx_LOGO_ANIMATION.22fbc3a5.mp4";